import { Reveal } from "@/components/Reveal";

export const Mission = () => (
  <section id="mission" className="border-b-2 border-[#f4f4f2] px-6 py-16 text-center md:py-24" data-testid="mission-section">
    <div className="mx-auto max-w-[920px]">
      <Reveal>
        <span className="font-mono2 text-[13px] font-bold uppercase tracking-[0.22em] md:text-sm">
          Warum machen wir das?
        </span>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display mt-5 text-[clamp(2.6rem,10vw,5.5rem)] uppercase leading-[0.92] tracking-tight">
          Musik
          <br />
          verbindet.
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mx-auto mt-8 max-w-[600px] text-left text-base leading-relaxed md:text-lg">
          House-Musik hat in Deutschland noch längst nicht die Bühne, die sie verdient. Wir wollen
          daran etwas ändern — ihr mehr Raum geben und mehr Menschen für sie begeistern.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mx-auto mt-5 max-w-[600px] text-left text-base leading-relaxed md:text-lg">
          Aber im Kern geht es uns um mehr als ums Feiern. Seit Corona ist an vielen Stellen echte
          Nähe zwischen Menschen verloren gegangen. Unsere Events sind unser Beitrag, das wieder
          zurückzuholen: echter Austausch, echte Begegnung, echtes Miteinander. Musik ist dabei das
          Werkzeug — die Verbindung zwischen Menschen ist das Ziel.
        </p>
      </Reveal>
      <Reveal delay={0.25}>
        <span className="font-mono2 mt-8 inline-block text-xs font-bold tracking-[0.06em] md:text-sm">
          — HOUSEGEMACHT
        </span>
      </Reveal>
    </div>
  </section>
);
